module.exports = __webpack_public_path__ + "img/34.f69518c2.jpg";